// Display helpers shared by the admin sidebar, the profile page, and anywhere a person is shown.

import api from "./api";

export const initialsOf = (user) => {
  const source = (user?.full_name || user?.email || "").trim();
  if (!source) return "A";
  const words = source.split(/[\s@._-]+/).filter(Boolean);
  return words
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
};

export const roleLabel = ({ counselorRole, isSuperuser }) => {
  if (counselorRole === "admin") return "School admin";
  if (counselorRole === "counselor") return "Counselor";
  if (isSuperuser) return "Administrator";
  return "Staff";
};

// Photo URLs are absolute (Cloud Storage) or, in local development, a /media/ path on the API host.
export const resolvePhotoUrl = (url) => {
  if (!url) return null;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url; // https:, blob:, data:
  return `${String(api.defaults.baseURL || "").replace(/\/$/, "")}${url}`;
};
